/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class EntranceDifficulty extends SubCatAccordion implements IsubCatAccordion
    {
        difficulty: string;
        toolTipHeader: string = "How selective are the schools you are looking for? (Selectivity covers the class rank, GPA, SAT scores and ACT scores of the incoming freshmen as well as the percentage of applicants who were accepted.)";
        popoverBigheader: string = "How selective are the schools you are looking for? (Selectivity covers the class rank, GPA, SAT scores and ACT scores of the incoming freshmen as well as the percentage of applicants who were accepted.)<br><ul><li>Most Difficult (about 30% or fewer of all applicants accepted)</li><li>Very Difficult (about 60% or fewer of all applicants accepted)</li><li>Moderately Difficult (about 85% or fewer of all applicants accepted.)</li><li>Minimally Difficult (up to 95% of applicants accepted (not 100%).</li><li>Noncompetitive (virtually all applicants accepted regardless of high school rank or test scores).</li></ul>";

        typeCbs = [{ type: "Most Difficult", isChecked: false },
            { type: "Very Difficult", isChecked: false },
            { type: "Moderately Difficult", isChecked: false },
            { type: "Minimally Difficult", isChecked: false },
            { type: "Noncompetitive", isChecked: false }];

        public getSelectedTypes(): string[]
        {
            var selectedTypes = new Array<string>();
            this.selected = false;

            if ( this.difficulty !== 'undefined' )
            {
                switch ( this.difficulty )
                {
                    case "Most Difficult":
                        this.typeCbs[0].isChecked = true;
                        this.typeCbs[1].isChecked = false;
                        this.typeCbs[2].isChecked = false;
                        this.typeCbs[3].isChecked = false;
                        this.typeCbs[4].isChecked = false;
                        break;
                    case "Very Difficult":
                        this.typeCbs[0].isChecked = false;
                        this.typeCbs[1].isChecked = true;
                        this.typeCbs[2].isChecked = false;
                        this.typeCbs[3].isChecked = false;
                        this.typeCbs[4].isChecked = false;
                        break;
                    case "Moderately Difficult":
                        this.typeCbs[0].isChecked = false;
                        this.typeCbs[1].isChecked = false;
                        this.typeCbs[2].isChecked = true;
                        this.typeCbs[3].isChecked = false;
                        this.typeCbs[4].isChecked = false;
                        break;
                    case "Minimally Difficult":
                        this.typeCbs[0].isChecked = false;
                        this.typeCbs[1].isChecked = false;
                        this.typeCbs[2].isChecked = false;
                        this.typeCbs[3].isChecked = true;
                        this.typeCbs[4].isChecked = false;
                        break;
                    case "Noncompetitive":
                        this.typeCbs[0].isChecked = false;
                        this.typeCbs[1].isChecked = false;
                        this.typeCbs[2].isChecked = false;
                        this.typeCbs[3].isChecked = false;
                        this.typeCbs[4].isChecked = true;
                        break;
                }
                selectedTypes.push( this.difficulty );
                this.selected = true;
            }
            return selectedTypes;
        }

        public reset()
        {
            this.difficulty = null;
            this.selected = false;
        }
    }
} 